module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "p25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/06_Contents#toc-ch1",
      "id": "ch1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/06_Contents#toc-ch1"
    }
  }, [_c('em', [_vm._v("Regular blood")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The first sentence of death imposed on a soldier of the BEF was carried out in the fifth week of the war; and the condemned soldier was "), _c('b', [_vm._v("Private Thomas Highgate")]), _vm._v(" from Kent. He had been born in the little village of Shoreham, near Sevenoaks and had joined the Army in February 1913. Like many who enlisted for Regular Army service, the lad had joined up at the age of 17.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Highgate’s battalion, 1 Royal West Kents, had been amongst the first to see action during the war. And following the retreat from Mons, after less than two weeks in action, the private had "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-1.jpg"
    }
  }), _vm._v(" deserted. On the day that he went missing his battalion had started to move northwards, advancing towards the Aisne. Highgate, who was wearing civilian clothing, was discovered by a gamekeeper hiding in a barn. His uniform was concealed nearby. When questioned he said, ‘I want to get out of it and this is how I am doing it.’"), _c('a', {
    attrs: {
      "href": "#/#r_fn1",
      "id": "fn1"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("1")])]), _vm._v(" Amazingly the gamekeeper was an Englishman and an ex-soldier too."), _c('a', {
    attrs: {
      "href": "#/#r_fn2",
      "id": "fn2"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("2")])]), _vm._v(" Private Highgate was then arrested by the Gendarmes, who soon handed him over to the British Military Authorities."), _c('a', {
    attrs: {
      "href": "#/#r_fn3",
      "id": "fn3"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On 6 September Private Highgate was tried by Field General Court Martial (FGCM) on a charge of desertion. He was unassisted in his defence – presumably at his own insistence – it being hoped that he was made aware of his right to have an officer speak on his behalf. Consequently, without the assistance of an officer to act as prisoner’s friend the private relied solely on the impartiality of the court’s president. Not surprisingly Private Highgate was found guilty. The sentence imposed was that he would suffer death by being shot.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On the following day the punishment was confirmed by the Commander-in-Chief Sir John French. At dawn on the 8th, just two days after his arrest, 19 year old Highgate was shot by a firing squad from 15 Brigade."), _c('a', {
    attrs: {
      "href": "#/#r_fn4",
      "id": "fn4"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("4")])]), _vm._v(" Shortly afterwards, brief details of the case appeared in the circular known as ‘Army Routine Orders’."), _c('a', {
    attrs: {
      "href": "#/#r_fn5",
      "id": "fn5"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("5")])]), _vm._v(" The theory was that such a disclosure would deter others.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In the post-war years the Imperial War Graves Commission was unable to locate Highgate’s grave, and consequently he is commemorated on La Ferté-sous-Jouarre Memorial to the missing.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("After the war the Army published lists of men who had died on active service. The records were produced in 80 parts by regiment or corps and were made available for sale, the volumes being called, "), _c('em', [_vm._v("Soldiers Died in the Great War")]), _vm._v(". It was believed that these lists did not "), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("contain the names of those who had been executed during the war. Yet Highgate’s name does appear, in part 53 which lists the dead of the Royal West Kent Regiment. The private’s cause of death is given as ‘Died of Wounds’.")])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("The exact reason for the inclusion of Highgate’s name is not known but it seems likely that the authorities, embarrassed by their predicament, sought to fudge the records and attempt a cover-up. It would also seem that they became confused by their own deception. The reason being that the information supplied by Army Records to the official registry of deaths states that Highgate had been ‘Killed in Action’.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn6",
      "id": "fn6"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("6")])]), _vm._v(" Private Highgate is not the only soldier who was shot to be commemorated in the volumes of "), _c('em', [_vm._v("Soldiers Died in the Great War")]), _vm._v(". A total of 14 men appear in various volumes, with two regiments listing all men who were executed, suggesting that some regiments were either unaware of the exclusion directive, or that they preferred to ignore its existence.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Prior to the trial of Private Highgate, General Sir Horace Smith-Dorrien (commanding II Corps) had recorded in his diary that a number of incidents of straggling and looting were to be tried by court martial on the evening of 4 September. Whilst these cases did not include Highgate, on 7 September Smith-Dorrien recorded that two men had been executed that day, one for plundering and the other for desertion."), _c('a', {
    attrs: {
      "href": "#/#r_fn7",
      "id": "fn7"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("7")])]), _vm._v(" The deserter was undoubtedly Highgate – a mistake having been made concerning the date – but no details can be found about a soldier executed on 7 September for plundering, and during the war no man was put to death solely for this offence.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On 14 September Army Routine Orders again carried news of courts martial."), _c('a', {
    attrs: {
      "href": "#/#r_fn8",
      "id": "fn8"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("8")])]), _vm._v(" Two battalion commanders, Lieutenant-Colonel A E Mainwaring, 2 Royal Dublin Fusiliers and Lieutenant-Colonel J F Elkington, 1 Royal Warwickshire Regiment had been found guilty of ‘behaving in a scandalous manner unbecoming the character of an officer and a gentleman’. The two officers had jointly agreed to surrender themselves and their troops to the Germans following a long retreat on 27 August. Both were sentenced to be cashiered. Two other courts martial also appeared in the same Routine Order. The offenders were a driver from the Army Service Corps and a private in the Dragoon Guards, both men had been convicted of sleeping on their posts. The two soldiers had been sentenced to death but the sentences had both been commuted to two years’ imprisonment with hard labour.")]), _vm._v(" "), _c('div', {
    staticClass: "image-float"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "img",
      "src": "images/ch1-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The second execution of the war concerned the offence of cowardice. The soldier, "), _c('b', [_vm._v("Private George Ward")]), _vm._v(" of 1 Royal Berkshire Regiment, was charged following an incident on the Aisne. On 14 September Ward’s battalion had been guarding the flanks during an uphill advance "), _c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("towards the Chemin des Dames. At around 9 am the enemy had opened up with shell fire and the advance had been checked. In the course of the bombardment Ward was seen to get up from his position and start to make his way to the rear. When challenged the soldier told his NCO that he had been hit by a shell burst.")])]), _c('a', {
    attrs: {
      "id": "p27"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("The unwounded private reported back to his battalion six days later, and soon afterwards, on 24 September, he was tried at Oeuilly Farm. Unlike Private Highgate, Ward had an officer to act as prisoner’s friend. Nevertheless it would seem that no defence was made. During the review procedure the court martial papers arrived on the desk of the Corps Commander Sir Douglas Haig. The General appended his thoughts to the papers. An example was required to prevent further cases occurring.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn9",
      "id": "fn9"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("9")])]), _vm._v(" Sir John French concurred and Private Ward, aged 20, was executed at Oeuilly at 5.56 pm on 26 September."), _c('a', {
    attrs: {
      "href": "#/#r_fn10",
      "id": "fn10"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("10")])]), _vm._v(" It was very unusual that the shooting had taken place in the late afternoon. During the remainder of the war, almost all other executions took place at dawn.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The account of a supposed eye-witness emerged after the war. The story related that as the condemned man was being taken out to be shot he broke away from his captors and tried to escape. He was shot as he ran and was wounded, then brought back on a stretcher. The sergeant of the guard was then ordered to ‘finish him off as he lay wounded."), _c('a', {
    attrs: {
      "href": "#/#r_fn11",
      "id": "fn11"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("11")])]), _vm._v(" There is no official record to confirm or deny this story, although it seems improbable. After the execution Ward’s body was buried south west of Oeuilly village – on the north bank of the river Aisne. However, after the war the soldier’s grave was never located and he too is commemorated on La Ferté-sous-Jouarre Memorial to the missing.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("What is astonishing about the case of Private Ward is that his offence occurred on his third day of active service. Ward had landed in France on 12 September"), _c('a', {
    attrs: {
      "href": "#/#r_fn12",
      "id": "fn12"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("12")])]), _vm._v(" and the brief duration of his service, before committing the crime that would cost him his life, was the shortest of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('b', [_vm._v("Private Edward Tanner")]), _vm._v(" of 1 Wiltshire Regiment was the oldest of the four British soldiers to be executed during 1914. At 33 he was nine years older than the average age of the others. Tanner "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-3.jpg"
    }
  }), _vm._v("had joined his battalion during the retreat from Mons and had seen action on the Aisne on three occasions before his battalion moved north to Flanders. The soldier had gone absent after recovering from a bout of dysentery. Whilst returning to his battalion Tanner hid his rifle and equipment, and like Private Highgate before him, disguised himself as a civilian."), _c('a', {
    attrs: {
      "href": "#/#r_fn13",
      "id": "fn13"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("13")])]), _vm._v(" The next day, on entering a village from the direction of the enemy lines, the private was accosted by an army officer who immediately became suspicious and arrested him as a deserter.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("At his court martial, Tanner stated that his nerves had been shattered "), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("by the shelling.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn14",
      "id": "fn14"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("14")])]), _vm._v(" The authorities were unsympathetic. The fact that the private had been arrested in civilian clothing was certainly noted by the court as an indication that the soldier intended to desert. In due course the execution was recorded in Routine Orders, although the date given was incorrect."), _c('a', {
    attrs: {
      "href": "#/#r_fn15",
      "id": "fn15"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("15")])]), _vm._v(" Private Tanner was shot at 7.10 am on 27 October, but after the war his grave was not located. Consequently he is commemorated on Le Touret Memorial to the missing, one of the many memorials that commemorate men whose graves disappeared on the Western Front.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The final soldier to be executed in 1914 was "), _c('b', [_vm._v("Private Archibald Browne")]), _vm._v(" of 2 Essex Regiment. Browne too was a veteran of August "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-4.jpg"
    }
  }), _vm._v(" 1914."), _c('a', {
    attrs: {
      "href": "#/#r_fn16",
      "id": "fn16"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("16")])]), _vm._v(" His battalion had taken part in the retreat from Mons and had been in action at Le Cateau, the Marne and the Aisne. Once in Flanders, Private Browne had deserted during November 1914, after assisting a sick soldier to an Aid Post. Following the previous pattern, Browne had dispensed with his army uniform and assumed the appearance of a civilian."), _c('a', {
    attrs: {
      "href": "#/#r_fn17",
      "id": "fn17"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("17")])]), _vm._v(" But a few days later he was arrested by the French police after breaking into an unoccupied house in Hazebrouck. On 9 December the soldier was court martialled on three charges: desertion, plundering and finally, showing his desperate plight, escaping from arrest. During the trial Browne stated he had been captured by the Germans and escaped, adding that subsequently he had been looking for his unit."), _c('a', {
    attrs: {
      "href": "#/#r_fn18",
      "id": "fn18"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("18")])]), _vm._v(" His story was not accepted and at 7 am on 19 December 26 year old Private Browne was executed. Notification appeared in Routine Orders on Christmas Eve."), _c('a', {
    attrs: {
      "href": "#/#r_fn19",
      "id": "fn19"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("19")])]), _vm._v(" At this period in the war it was not uncommon for men who were under arrest to escape confinement. Browne’s story that he had been captured by the Germans and had then escaped was not as incredible as might first be thought. Later in the war the unbroken trench lines from Switzerland to the sea made this event very unlikely, but in 1914 it was a real possibility and a number of such occurrences have been documented. In early 1915, when another soldier also claimed he had been captured by the Germans and had escaped, he too was executed.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("As in the cases of the other men executed in 1914, the grave of Private Browne could not be found after the war, but today his name can be seen on the Ploegsteert Memorial to the missing.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The recent publication of an officer’s diary from the Great War included details that a double execution had taken place in Rouen in 1914."), _c('a', {
    attrs: {
      "href": "#/#r_fn20",
      "id": "fn20"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("20")])]), _vm._v(" The diary entry was not made with the benefit of personal knowledge but from hearsay. Such rumours were very prevalent throughout the war, and extensive enquiries have failed to trace any such events. Consequently it must be stated that there is no foundation for this unsubstantiated yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("In spite of a considerable amount of trucing in Christmas 1914, some of which continued into the new year, the spirit of cordiality was not universally evident. On New Year’s Day 1915 the Germans launched a number of attacks near Cuinchy, capturing a machine gun post and a handful of observation posts that stood in front of the main positions. It was not a good start to the new year, and the official historians later wrote, ‘the depression of some of the troops during the winter of 1914-15 was evident. It was of the utmost importance as regards morale that our men should see that the enemy could be paid back in kind and was not going to have things all his own way.’")]), _c('a', {
    attrs: {
      "href": "#/#r_fn21",
      "id": "fn21"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Amongst those experiencing such depression were two Londoners from 4th Company, 2 Middlesex Regiment. "), _c('b', [_vm._v("Private Sheffield")]), _vm._v(" and "), _c('b', [_vm._v("Private Ball")]), _vm._v(" had gone absent in mid December and were shot early in 1915, in the first double execution of the war. The two "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-5.jpg"
    }
  }), _vm._v("privates had deserted after only six weeks on active service, going absent as their battalion made its way to the trenches prior to an attack on Neuve Chapelle. The two soldiers were discovered hiding under straw in a barn, and pretended to be French civilians."), _c('a', {
    attrs: {
      "href": "#/#r_fn22",
      "id": "fn22"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("22")])]), _vm._v(" The fugitives stood trial on the penultimate day of December when the prosecution alleged that the soldiers had ‘attempted to desert’.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Presumably the close proximity of the two men to their unit determined that this would be the charge as opposed to the more usual charge of ‘desertion’. (Strictly speaking the two men should not have been charged with ‘attempting to desert’ but with ‘desertion’. Chapter 3, paragraph 18 of the "), _c('em', [_vm._v("Manual of Military Law")]), _vm._v(" explains the offence of attempting to desert: ‘If a soldier commits an act which is apparently a prelude to, or an attempt at, desertion, although no actual absence can be proved, as if he is caught in the act of slipping past a sentry, or climbing over a barrack wall in plain clothes, he may be charged with an attempt to desert.’) On 8 January the Adjutant-General of 8 Division received notification by telegram that the sentences had been confirmed, and the executions took place at 7.30 am on 12 January 1915."), _c('a', {
    attrs: {
      "href": "#/#r_fn23",
      "id": "fn23"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("23")])]), _vm._v(" Again details of the executions were circulated for the attention of potential offenders, an officer recording the notification in his diary."), _c('a', {
    attrs: {
      "href": "#/#r_fn24",
      "id": "fn24"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("24")])]), _vm._v(" Private Sheffield came from South Tottenham and was aged 26 when he died. Private Ball lived at Queens Park and was six years his junior. Although the Adjutant-General recorded the events in his diary, after the Armistice the graves were not found. Both men are commemorated on Le Touret Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In cases of desertion two aspects of the offence were likely to increase the likelihood of the death sentence being put into effect. Firstly soldiers who were caught wearing civilian clothing were regarded as clearly showing their intention to desert. It was considered far more serious for "), _c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("a soldier to be arrested in civilian clothing and without equipment than if he were apprehended in khaki and still in possession of his kit. In all cases of desertion hitherto, the soldiers had been arrested in civilian clothing. In the cases of Ball and Sheffield they had also compounded their offences by deserting to avoid service in the line. It was this second factor which was considered equally serious to a civilian disguise. Men who deserted specifically to avoid a dangerous or potentially dangerous duty ran the greatest risk of facing a firing squad – the duration of the absence was immaterial under such circumstances. To return to duty, even after a very short interval of time – a day or less, would not minimise the prospects of a death penalty being imposed. The fatal element was that the offence had been committed to avoid personal danger. This aspect – avoiding personal danger by deserting – is not far removed from the offence of cowardice. The differences were, firstly that the offence of desertion did not require an audience to prove the case, and secondly the crime did not have to be committed in action.")])]), _c('a', {
    attrs: {
      "id": "p30"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("The first NCO to be executed during the war was a corporal in 2 Lancashire Fusiliers. "), _c('b', [_vm._v("Corporal George Latham")]), _vm._v(" was a regular soldier "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-6.jpg"
    }
  }), _vm._v("who had deserted at Le Cateau on 27 August. He was absent for several months and was eventually returned to his unit as a straggler.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn25",
      "id": "fn25"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("25")])]), _vm._v(" The soldier again went absent for a further three weeks, until he was arrested on 21 December by the Military Police at Nieppe, where he was living with a French woman."), _c('a', {
    attrs: {
      "href": "#/#r_fn26",
      "id": "fn26"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("26")])]), _vm._v(" At his trial this 23 year soldier, who had a wife living near Birmingham, offered no explanation for his behaviour. On 22 January the corporal suffered the extreme penalty for his errant ways. Latham’s grave was identified after the war and his wife decided on the inscription – "), _c('em', [_vm._v("Rest in Peace")]), _vm._v(". The grave lies in plot 2, row F, grave 17 of Trois Arbres Cemetery, Steenwerck, France.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("At the end of January 1915 a further double execution took place. Both men were in their twenties and were in 1 Irish Guards. Private "), _c('b', [_vm._v("Thomas Cummings")]), _vm._v(" and "), _c('b', [_vm._v("Private Albert Smythe")]), _vm._v(" had each served for "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-7.jpg"
    }
  }), _vm._v("a number of years before the war. Their battalion, which had been in action continually since Mons, was fighting in the Ypres Salient when in November 1914 the two men deserted. As in the previous case, a French woman had been harbouring the men. The duo had been unearthed by the Military Police during a raid on a barn."), _c('a', {
    attrs: {
      "href": "#/#r_fn27",
      "id": "fn27"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("27")])]), _vm._v(" After the trial the battalion commander added his comments to the proceedings, stating that Cummings was an excellent soldier, but that Smythe’s reputation was disappointing. Nevertheless, both sentences were confirmed – and subsequently carried out on 28 January. The familiar notification soon appeared in General Routine Orders."), _c('a', {
    attrs: {
      "href": "#/#r_fn28",
      "id": "fn28"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("28")])]), _vm._v(" Neither man’s "), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("grave was found after the war and both men are commemorated on Le Touret Memorial.")])]), _c('a', {
    attrs: {
      "id": "p31"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_c('b', [_vm._v("Private William Scotton")]), _vm._v(" pre-empted the war by enlisting in Middlesex Regiment at the end of July 1914. After a brief period of training the private was drafted to 4 Battalion which was serving in the Ypres "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-8.jpg"
    }
  }), _vm._v("Salient. At the end of December Scotton was convicted of going absent, yet a month later, on 23 January, he repeated the offence, his platoon having been warned for the trenches.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn29",
      "id": "fn29"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("29")])]), _vm._v(" The private reported himself the next day, after his unit’s return from the line, and was placed under arrest."), _c('a', {
    attrs: {
      "href": "#/#r_fn30",
      "id": "fn30"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("30")])]), _vm._v(" The court martial papers carried comments suggesting that the soldier was a weakling and that discipline in his battalion was bad – there was no recommendation to mercy. The sentence of death was carried out at Vierstraat on 3 February by a firing squad of eight men and an NCO from the condemned man’s unit; and the whole battalion was paraded to witness the event."), _c('a', {
    attrs: {
      "href": "#/#r_fn31",
      "id": "fn31"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("31")])]), _vm._v(" The grave of Private Scotton, aged only 19 at the time of his death, was not discovered after the war and he is commemorated on the Menin Gate Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("A third double execution took place in early February 1915, and the circumstances are surprising to say the least. The two soldiers were both privates in 1 Royal Scots Fusiliers who were charged with "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-9.jpg"
    }
  }), _vm._v(" attempting to desert. "), _c('b', [_vm._v("Private Andrew Evans")]), _vm._v(" was probably a Reservist. His Great War service had commenced in August 1914, and it is reckoned, based on his army number, that he was simply re-joining the colours. Private Evans was drafted to 1 Battalion on 10 October 1914."), _c('a', {
    attrs: {
      "href": "#/#r_fn32",
      "id": "fn32"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('b', [_vm._v("Private Joseph Byers")]), _vm._v(" however, had enlisted at the age of 17."), _c('a', {
    attrs: {
      "href": "#/#r_fn33",
      "id": "fn33"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("33")])]), _vm._v(" Anthony Babington in his book, "), _c('em', [_vm._v("For the Sake of Example")]), _vm._v(" mistakenly remarks that the first Kitchener volunteer to be executed met his end on 1 July 1915. This is not the case, Private Byers was the first Kitchener volunteer to be executed in the war. Byers enlisted on 20 November and received only a fortnight’s rudimentary training in Britain before being despatched to France."), _c('a', {
    attrs: {
      "href": "#/#r_fn34",
      "id": "fn34"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Hence it can be seen that Private Byers had seen little service, as together with his comrade Private Evans the two men were tried on 30 January. The evidence indicated that they had been absent from parade, prior to their battalion proceeding to the front. Byers pleaded guilty to the charge, a decision that later was viewed with concern by the confirming officers and legal advisers. Subsequently instructions were issued that when a capital crime was involved, then irrespective of a soldier’s wish, a plea of not guilty would be entered and the case heard as normal – with witnesses giving evidence on oath."), _c('a', {
    attrs: {
      "href": "#/#r_fn35",
      "id": "fn35"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("One factor that the reviewing authorities omitted to consider further was that Private Byers was unrepresented at his trial. Perhaps an "), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("additional directive should have been issued that soldiers under the age of majority must be represented when on trial. Military indifference would seem to have had a rather blinkered approach to this equally serious oversight.")])]), _c('a', {
    attrs: {
      "id": "p32"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("In spite of the deliberations the sentences of death on Privates Byers and Evans were very quickly confirmed, and the duo faced a firing squad at Locre on 6 February. Both the battalion war diary")]), _c('a', {
    attrs: {
      "href": "#/#r_fn36",
      "id": "fn36"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("36")])]), _vm._v(" and General Routine Orders"), _c('a', {
    attrs: {
      "href": "#/#r_fn37",
      "id": "fn37"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("37")])]), _vm._v(" recorded the executions, but a rumour circulated that one man had not died instantly – and was eventually killed by a third volley."), _c('a', {
    attrs: {
      "href": "#/#r_fn38",
      "id": "fn38"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("38")])]), _vm._v(" Given that the story was true, it seems almost certain that the firing squad had been reluctant to shoot the young Joseph Byers, choosing deliberately to fire wide. Privates Byers and Evans are buried side-by-side in Locre Churchyard just yards from the Franco-Belgian border.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The month of January 1915 was also unusual for another soldier serving in 1 Royal Scots Fusiliers. The circumstances of the case are unique, and all the material facts have not come to light – however the soldier concerned was lucky to survive the war.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("William Mitchell enlisted in the Royal Scots Fusiliers on 15 November 1906 and after the war broke out proceeded overseas on 6 October 1914 with 2 Battalion"), _c('a', {
    attrs: {
      "href": "#/#r_fn39",
      "id": "fn39"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("39")])]), _vm._v(". For a reason that is not clear, after a short period of service Mitchell was transferred to 1 Battalion.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Early in 1915 Private Mitchell ran away from the trenches during hostile operations, but was later captured. On 15 January he was tried on charges of both absence and cowardice before being sentenced to death. The resourceful soldier however escaped from custody, and denied the firing squad its prey."), _c('a', {
    attrs: {
      "href": "#/#r_fn40",
      "id": "fn40"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("40")])]), _vm._v(" Quite how long the private remained at liberty is not known, but it was almost certainly a number of months, maybe even years. The circumstances under which the soldier returned to duty are unknown, but it is clear that he subsequently served honourably.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("During the time that Private Mitchell was absent the Suspension of Sentences Act came into being and it seems almost certain that upon his return to service, the soldier received the benefit of the Act’s provisions. The official record (which it is believed was compiled in September 1916) states against the soldier’s name, ‘Escaped from custody. No intimation yet as to whether sentence [of death] is carried out’."), _c('a', {
    attrs: {
      "href": "#/#r_fn41",
      "id": "fn41"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In fact Private Mitchell never faced the firing squad, but he did not survive the war unscathed. In 1919 he was issued with a Silver Wound Badge for ‘Services Rendered’ during the Great War, the private having been discharged as ‘no longer physically fit for war service’,"), _c('a', {
    attrs: {
      "href": "#/#r_fn42",
      "id": "fn42"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("42")])]), _vm._v(" on 6 April 1919."), _c('a', {
    attrs: {
      "href": "#/#r_fn43",
      "id": "fn43"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("43")])]), _vm._v(" Aged 32 on his discharge, William Mitchell was the only soldier to have cheated the firing squad.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("On 30 January a private from 2 Royal Warwickshire Regiment was tried for desertion, although the evidence might well have warranted a charge of cowardice. Some considerable time previously, on 24 October, "), _c('b', [_vm._v("Private A Pitts")]), _vm._v(" had left his battalion and made off whilst under fire near the village of Zonnebeke – in the Ypres Salient.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn44",
      "id": "fn44"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("44")])]), _vm._v(" "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-10.jpg"
    }
  }), _vm._v("Lying low, the private made his way to the coast, hoping to get to England. When he was captured at Boulogne on 12 January he gave false particulars in a vain attempt to avoid detection, but he was soon returned to his battalion to face a court martial. On 8 February Private Pitts was shot in Rue Bataille near Sailly-sur-la-Lys."), _c('a', {
    attrs: {
      "href": "#/#r_fn45",
      "id": "fn45"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("45")])]), _vm._v(" The location of his grave was subsequently lost and he is commemorated on the Ploegsteert Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("At the end of January written orders, issued by the staff of 1 Division, showed that absenteeism was causing considerable administrative difficulties. The problem arose because soldiers were being reported as absentees, when in fact they had been attached to other units. In order to alleviate this problem, orders were given that at the end of each month units would submit details of all absentees to the APM. Subsequently, at the beginning of each of the following months, a list of such men would be circulated."), _c('a', {
    attrs: {
      "href": "#/#r_fn46",
      "id": "fn46"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Early in February five soldiers from 1 Cheshire Regiment were charged with quitting their posts. "), _c('b', [_vm._v("Corporal George Povey")]), _vm._v(", together with four privates under his command, had been in a position in the front line near Wulverghem."), _c('a', {
    attrs: {
      "href": "#/#r_fn47",
      "id": "fn47"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("47")])]), _vm._v(" During the early hours of darkness on 28 January a German patrol had crossed no-man’s-land, grabbed a sentry’s rifle and escaped. In the following minutes, "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-11.jpg"
    }
  }), _vm._v("as rifle fire broke out, a rumour circulated that the Germans were actually in the British trenches. As a result Corporal Povey and his four men fled back to the support trench.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("At their trial the group maintained that they had departed after hearing a shout to clear out as they had been overrun. When it was discovered that the British lines had not been overwhelmed Corporal Povey and the others were arrested. 23 year old Povey was sentenced to death and shot on 11 February,"), _c('a', {
    attrs: {
      "href": "#/#r_fn48",
      "id": "fn48"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("48")])]), _vm._v(" and the privates were sent to prison."), _c('a', {
    attrs: {
      "href": "#/#r_fn49",
      "id": "fn49"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("49")])]), _vm._v(" After the execution had been carried out it was rumoured that the five had been asleep, and had been startled by the approaching German patrol"), _c('a', {
    attrs: {
      "href": "#/#r_fn50",
      "id": "fn50"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("50")])]), _vm._v(" – which could have accounted for the party’s panicky flight. As Corporal Povey has no known grave he is commemorated on the Menin Gate Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On 20 January 1915 2 Welsh Regiment were engaged in digging second line trenches near Béthune. Snow fell during the morning and in the appalling weather the regimental goat died of heart failure."), _c('a', {
    attrs: {
      "href": "#/#r_fn51",
      "id": "fn51"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("51")])]), _vm._v(" During the evening "), _c('b', [_vm._v("Lance-Corporal William Price")]), _vm._v(" and "), _c('b', [_vm._v("Private Richard "), _c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("Morgan")])]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v(" of ‘C’ Company got drunk and shot their Company Sergeant-Major.")])]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("Price was aged 41. Morgan was 32 – the same age as the victim, "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-12.jpg"
    }
  }), _vm._v(" CSM Hayes. All of the men were old soldiers, with Hughie Hayes having enlisted as a boy soldier at the age of fourteen, before seeing action in the Boer War. Hayes’ army service, of eighteen and a half years, ended when he succumbed to his injuries the day after he had been shot. (Bethune Town Cemetery register, gives CSM Hayes’ cause of death as died of ‘accidental injuries’.) On 28 January papers were sent to Corps HQ for consideration of charges of murder against the two men.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn52",
      "id": "fn52"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("52")])]), _vm._v(" Under instructions from 1 Corps a General Court Martial was ordered for 6 February to hear the case.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The trial commenced at Lillers at 10 am with Captain Lyttleton, (Staff Captain, 5 Brigade) acting as prosecutor and with Brigadier-General Lowther presiding. Other court martial members were furnished from 1 Division. After considering the evidence guilty verdicts were returned and sentences of death passed. The Reverend Harry Blackburne (who later became the Canon of Windsor) was serving as a chaplain in 1 Division at the time. He had attended the men before their trial and did so again at their execution. Blackburne recalled how at the execution, he read the story of the Prodigal Son and prayed before the sentences were carried out."), _c('a', {
    attrs: {
      "href": "#/#r_fn53",
      "id": "fn53"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("53")])]), _vm._v(" All three men, the victim and his murderers, are buried in Béthune Town Cemetery. In 1929 an account by Robert Graves in "), _c('em', [_vm._v("Goodbye To All That")]), _vm._v(", maintained that the company sergeant-major had been shot accidentally. The story continues that the two soldiers had intended to shoot their platoon sergeant, who it was alleged had been victimising the duo. Graves states that the French military governor was present at the execution and that the pair’s last words were ‘Stick it, the Welch’ – the purported battalion rallying cry. Graves undoubtedly heard of the events second-hand, as he himself only joined the battalion in May 1915, and he described the offenders as two young miners. The same day that this double execution took place, 15 February, a soldier was shot at Locre for desertion. 20 "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-13.jpg"
    }
  }), _vm._v("year old "), _c('b', [_vm._v("Private George Collins")]), _vm._v(" of 1 Lincolnshire Regiment had been undefended at his trial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In mid February the Commander-in-Chief expressed his concern about the increasing tendency of courts martial to impose the extreme penalty. In a confidential memorandum he specified a number of details, which in future, would be supplied with the court martial papers. Firstly, he wanted to know about the soldier’s character, both as a fighting man and also in general, together with the man’s length of service with the BEF. Secondly, the Field-Marshal wanted to know the current state of discipline within the "), _c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("condemned man’s unit. Additionally, he wished to know whether the crime had been committed deliberately – with the intention of avoiding a particular duty. And finally, details were required from all reviewing officers commenting on why they thought the sentence should be carried out. The Commander-in-Chief had been at pains to point out that a soldier should not face a death sentence solely because he had gone absent following a drunken spree.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn54",
      "id": "fn54"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("54")])]), _vm._v(" By coincidence, it has since been reported that just such a situation arose, immediately after the circulation of this memo.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In March 1915 two soldiers from 1 West Yorkshire Regiment were convicted of desertion and then were shot within a few days of each other. The first, L"), _c('b', [_vm._v("ance-Corporal Alfred Atkinson")]), _vm._v(", deserted whilst in rest; the battalion being under orders to proceed to the front. In January of that year Atkinson had won a sum of money gambling and after a bout of drinking subsequently deserted."), _c('a', {
    attrs: {
      "href": "#/#r_fn55",
      "id": "fn55"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("55")])]), _vm._v(" After three "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-14.jpg"
    }
  }), _vm._v("weeks he was then arrested by the Military Police. At his trial the court was told that Atkinson was a good soldier – and previously of excellent character. As a result his sentence bore a recommendation to mercy. A soldier serving with the battalion at the time later confirmed this opinion, saying that Atkinson was ‘a clean, smart , brave soldier, respected by all his comrades’."), _c('a', {
    attrs: {
      "href": "#/#r_fn56",
      "id": "fn56"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("When General Sir Horace Smith-Dorrien reviewed the proceedings he was of the opinion that an example was required, and the sentence was confirmed. Labour MP Ernest Thurtle, was later presented with an eyewitness account of the final details:")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('em', [_vm._v("‘The two men I selected for the firing party went with the adjutant.")]), _vm._v(" [Presumably these two men formed only part of the firing squad.] "), _c('em', [_vm._v("When they came back, tough characters though they were supposed to be, they were sick, they screamed in their sleep, they vomited immediately after eating. All they could say was: “The sight was horrible, made more so by the fact that we had shot one of our own men”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The other West Yorks deserter was "), _c('b', [_vm._v("Private Ernest Kirk")]), _vm._v(". He too was executed by a firing squad from his own battalion. Both shootings took place at the Asylum at Armentiéres during the first week of March. The eyewitness again recalled the events:")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('em', [_vm._v("‘I witnessed a scene I shall never forget. Men I had known for years as clean, decent, self-respecting soldiers, whose only offence was an occasional military “drunk”, screamed out, begging not to be made into murderers. They offered me all they had if I would not take them for the job, and finally, when twelve of them found themselves outside, selected for the dreaded firing party, they called me all the names they could lay their tongues to. I remained with the guard for three days, and I leave you to guess what I had to put up with. I am poor, with eight children, I would not go through three more [sic] such sights for £1000.’"), _c('a', {
    attrs: {
      "href": "#/#r_fn57",
      "id": "fn57"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("Lance-Corporal Atkinson and Private Kirk are both buried in Chapelle d’Armentieres Old Military Cemetery.")])]), _c('a', {
    attrs: {
      "id": "p36"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("In March 1915 a private in 2 Leinster Regiment was shot for desertion; and the soldier had also been court martialled for being drunk and disorderly. "), _c('b', [_vm._v("Private Thomas Hope")]), _vm._v(" had joined his battalion in September 1914 and remained with it for just over two months before deserting on "), _c('img', {
    staticClass: "image-float",
    attrs: {
      "alt": "img",
      "src": "images/ch1-15.jpg"
    }
  }), _vm._v("23 December. At the time the soldier was in the front line trenches at L’Epiniette and had been detailed to fetch rations from a dump in the rear.")]), _c('a', {
    attrs: {
      "href": "#/#r_fn58",
      "id": "fn58"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("58")])]), _vm._v(" It was snowing,"), _c('a', {
    attrs: {
      "href": "#/#r_fn59",
      "id": "fn59"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("59")])]), _vm._v(" and Hope never returned from this task but was captured some six weeks later on 9 February – only a short distance away in Armentiéres. The private had adopted an unusual disguise, as he was arrested whilst masquerading as a lance-corporal of the Military Police, and had initially refused to give his name. At his trial, on 14 February, Hope told the court that whilst returning with the rations he had been captured by the enemy, successfully escaped, and had crossed back to the British lines. Private Hope was the second soldier to be executed who claimed such a feat. The accused explained away his presence in Armentieres by saying that he was looking for his battalion. Significantly the young soldier was not defended at his trial."), _c('a', {
    attrs: {
      "href": "#/#r_fn60",
      "id": "fn60"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("A more plausible reason for the private’s desertion emerged when he informed the court that he had gone absent on impulse after hearing that his two brothers had been killed in action. (Private Hope was the first of a number of offenders who claimed that the death of a relative had contributed to the commission of their offence. However, research has shown that many deserters, executed in similar circumstances, did not make this fact known to the court.) Hope’s record weighed heavily against him when it was revealed that he had two previous convictions for absence without leave. One in Cambridge, for which he had received 56 days’ field punishment no.1, and on a second occasion (in France) for going absent during a march, for which he received months field punishment. As if the outlook was not bleak enough, the commanding officer, Major Bullen-Smith, appended a damning indictment to the proceedings, stating that Hope had made his mind up not to serve creditably and avoided all military duty. It was an example of just how influential a reviewing officer’s opinion could be. On 27 February the soldier’s fate was sealed when Sir John French confirmed the sentence of death."), _c('a', {
    attrs: {
      "href": "#/#r_fn61",
      "id": "fn61"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("61")])]), _vm._v(" Private Hope, aged 20, was executed on 2 March. The grave was not located after the war, but his name is commemorated on the Ploegsteert Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On 6 March a deserter from 2 Border Regiment was shot. His place of capture was a clear indication that he intended to soldier no more. "), _c('b', [_vm._v("Private James Briggs")]), _vm._v(" went absent on 20 January while his battalion were out of the line in rest. Later that same day they moved up into "), _c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("the trenches,")]), _c('a', {
    attrs: {
      "href": "#/#r_fn62",
      "id": "fn62"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("62")])]), _vm._v(" whilst Briggs quickly caught a train to the coast and "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-16.jpg"
    }
  }), _vm._v(" ‘stowed away’ in the hold of a mail boat due to sail from Le Havre. His arrest came just two days after his flight and when questioned, he told a story about being directed from a hospital at Rouen, on to a hospital ship."), _c('a', {
    attrs: {
      "href": "#/#r_fn63",
      "id": "fn63"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("63")])]), _vm._v(" These details, brought out at his trial, were also complemented by a charge of escaping; and in due course the sentence of death was confirmed. Like the majority of previous executions the condemned man faced a firing squad of men from own battalion. An eyewitness recorded that Briggs displayed no fear and that, ‘he marched to his death with a soldier’s heart’."), _c('a', {
    attrs: {
      "href": "#/#r_fn64",
      "id": "fn64"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("64")])]), _vm._v(" The execution took place at 7.30 am on 6 March. After the war Private Briggs’ grave was not found but his name is recorded on Le Touret Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On the following day "), _c('b', [_vm._v("Private John Duncan")]), _vm._v(" of 1 Cameron Highlanders faced a firing squad. The execution, like Private Ward’s in 1914, was unusual in that it took place in the late afternoon – on "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-17.jpg"
    }
  }), _vm._v("this occasion at 5.30 pm."), _c('a', {
    attrs: {
      "href": "#/#r_fn65",
      "id": "fn65"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("65")])]), _vm._v(" Duncan, a Glaswegian, was an Army Reservist who had deserted after only one week in action. The soldier’s name appears in the official casualty returns, recorded as died of wounds,"), _c('a', {
    attrs: {
      "href": "#/#r_fn66",
      "id": "fn66"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("66")])]), _vm._v(" although he was killed by a firing squad from his own battalion."), _c('a', {
    attrs: {
      "href": "#/#r_fn67",
      "id": "fn67"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("67")])]), _vm._v(" After the war Private Duncan’s grave was not found and he is commemorated on Le Touret Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("March 1915 saw the first case of a soldier being executed where there would seem to be evidence that the condemned man was suffering from shellshock. Medical knowledge did not generally recognise the condition at the time, and "), _c('b', [_vm._v("Lance-Sergeant William Walton")]), _vm._v(" of 2 King’s Royal Rifle Corps was doomed as a result. Walton, a veteran of the Battle of Mons, had deserted after the first Battle of Ypres "), _c('img', {
    staticClass: "image-float1",
    attrs: {
      "alt": "img",
      "src": "images/ch1-18.jpg"
    }
  }), _vm._v("in 1914. After about a month he took refuge in the house of a civilian in a small village near St Omer. Appearing to be wounded in the hand, he had called at the house and begged to be given a bed. At the beginning of March, as the result of a tip-off, Walton was arrested. Under interrogation he appeared to have difficulty in answering even elementary questions, but he eventually made a statement to the effect that he had undergone a nervous breakdown. At his court martial he repeated this defence – but to no avail for he was sentenced to death. Although medical observations were eventually ordered to be kept on the sergeant it is doubtful whether much examination actually took place."), _c('a', {
    attrs: {
      "href": "#/#r_fn68",
      "id": "fn68"
    }
  }, [_c('sup', {
    staticClass: "fn-num"
  }, [_vm._v("68")])]), _vm._v(" Medical and military authorities seemed unsympathetic to his plight and he was shot on 23 March. Sergeant Walton, the most senior NCO to have been shot to date, was aged 26, and was buried in Longuenesse (Souvenir) Cemetery at St Omer.")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('div', {
    staticClass: "fn"
  }, [_c('h4', {
    staticClass: "paracenter"
  }, [_c('a', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("NOTES")])]), _c('a', {
    attrs: {
      "id": "p38"
    }
  }), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "p38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "r_fn1"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("1")])]), _vm._v(" WO93/49, Summary of First World War capital court martial cases.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "r_fn2"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("2")])]), _vm._v(" Brigadier-General Count Gleichen, "), _c('em', [_vm._v("The Doings of the Fifteenth Infantry Brigade")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "r_fn3"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("3")])]), _vm._v(" Major-General Sir Wyndham Childs, "), _c('em', [_vm._v("Episodes and Reflections")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "r_fn4"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("4")])]), _vm._v(" Brigadier-General Count Gleichen, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "r_fn5"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("5")])]), _vm._v(" Copies appear in WO95/25, War Diary of the Adjutant-General, GHQ.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "r_fn6"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("6")])]), _vm._v(" Records of the General Register Office, London.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "r_fn7"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("7")])]), _vm._v(" CAB 45/206. Diary of Sir Horace Smith-Dorrien.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "r_fn8"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("8")])]), _vm._v(" WO95/25, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "r_fn9"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("9")])]), _vm._v(" Anthony Babington, "), _c('em', [_vm._v("For the Sake of Example")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "r_fn10"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("10")])]), _vm._v(" WO95/1361, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "r_fn11"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("11")])]), _vm._v(" Ernest Thurtle’s pamphlet, "), _c('em', [_vm._v("Shootings at Dawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "r_fn12"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("12")])]), _vm._v(" WO329/1, Index to the "), _c('em', [_vm._v("Great War Medal Rolls")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "r_fn13"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("13")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "r_fn14"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("14")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "r_fn15"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("15")])]), _vm._v(" WO95/25, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "r_fn16"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("16")])]), _vm._v(" WO329/1, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "r_fn17"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("17")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "r_fn18"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("18")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "r_fn19"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("19")])]), _vm._v(" WO95/25, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "r_fn20"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("20")])]), _vm._v(" "), _c('em', [_vm._v("The Burgoyne Diaries")]), _vm._v(", published by Thomas Harmsworth.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "r_fn21"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("21")])]), _vm._v(" Brigadier Sir J E Edmonds & Captain G C Wynne, "), _c('em', [_vm._v("Military Operations France & Belgium")]), _vm._v(", 79/5, Volume 1")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "r_fn22"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("22")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "r_fn23"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("23")])]), _vm._v(" WO95/1680, War Diary of Adjutant-General, 8 Division.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "r_fn24"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("24")])]), _vm._v(" "), _c('em', [_vm._v("The Burgoyne Diaries")]), _vm._v(", op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "r_fn25"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("25")])]), _vm._v(" WO95/646, War Diary of Adjutant-General, II Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "r_fn26"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("26")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "r_fn27"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("27")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "r_fn28"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("28")])]), _vm._v(" WO95/25, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "r_fn29"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("29")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "r_fn30"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("30")])]), _vm._v(" WO95/646, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "r_fn31"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("31")])]), _vm._v(" WO95/1416, War Diary of 8 Brigade HQ.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "r_fn32"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("32")])]), _vm._v(" WO329/2442, 1914 "), _c('em', [_vm._v("Star Medal Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "r_fn33"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("33")])]), _vm._v(" Records of birth suggest that Byers was 17-years-old.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "r_fn34"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("34")])]), _vm._v(" WO329/2442, "), _c('em', [_vm._v("1914 Star Medal Roll")]), _vm._v(", gives the date of Private Byers’ landing in France as 5 December 1914. The date of his enlistment has been deduced from known dates for soldiers with very close army numbers. There is no doubt that both dates are correct.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "r_fn35"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("35")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "r_fn36"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("36")])]), _vm._v(" WO95/1432, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "r_fn37"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("37")])]), _vm._v(" Copies can be seen in WO95/1449, War Diary of Adjutant-General, 4 Division.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "r_fn38"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("38")])]), _vm._v(" "), _c('em', [_vm._v("The Burgoyne Diaries")]), _vm._v(", op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "r_fn39"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("39")])]), _vm._v(" WO329/1, op cit. – note that Private Mitchell has two record cards.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "r_fn40"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("40")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "r_fn41"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("41")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "r_fn42"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("42")])]), _vm._v(" King’s Regulations No.392 xvia – this included unfitness for medical reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "r_fn43"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("43")])]), _vm._v(" WO329/3036, Silver Wound Badge Roll.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "r_fn44"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("44")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "r_fn45"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("45")])]), _vm._v(" WO95/1636, War Diary of Adjutant-General, 7 Division.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "r_fn46"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("46")])]), _vm._v(" WO95/1275, War Diary of 3 Brigade HQ.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "r_fn47"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("47")])]), _vm._v(" WO95/1571, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "r_fn48"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("48")])]), _vm._v(" WO329/1001, "), _c('em', [_vm._v("British War & Victory Medal Roll")]), _vm._v(" states that Povey was also reduced to the rank of private for his crime.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "r_fn49"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("49")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "r_fn50"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("50")])]), _vm._v(" Memoirs of Lieutenant T E Rogers, Imperial War Museum, reference IWM, DS/MISC/81.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "r_fn51"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("51")])]), _vm._v(" WO95/1281, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "r_fn52"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("52")])]), _vm._v(" WO95/1235, War Diary of Adjutant-General, 1 Division.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "r_fn53"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("53")])]), _vm._v(" Harry W Blackburne DSO, MC, "), _c('em', [_vm._v("This Also Happened on the Western Front")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "r_fn54"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("54")])]), _vm._v(" WO95/1091, A copy of the memorandum exists in the War Diary of Adjutant-General, Indian Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "r_fn55"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("55")])]), _vm._v(" Account given to Ernest Thurtle, and published in his pamphlet, Shootings at Dawn.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "p39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "r_fn56"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("56")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "r_fn57"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("57")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn58",
      "id": "r_fn58"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("58")])]), _vm._v(" Anthony Babington, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn59",
      "id": "r_fn59"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("59")])]), _vm._v(" WO95/1612, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn60",
      "id": "r_fn60"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("60")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn61",
      "id": "r_fn61"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("61")])]), _vm._v(" Hansard, 20 January 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn62",
      "id": "r_fn62"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("62")])]), _vm._v(" WO95/1655, Battalion War Diary.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn63",
      "id": "r_fn63"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("63")])]), _vm._v(" WO93/49, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn64",
      "id": "r_fn64"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("64")])]), _vm._v(" Diary of an unidentified soldier of the Border Regiment. Imperial War Museum reference: Misc 550.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn65",
      "id": "r_fn65"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("65")])]), _vm._v(" WO95/25, op cit.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn66",
      "id": "r_fn66"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("66")])]), _vm._v(" "), _c('em', [_vm._v("Soldiers Died in the Great War")]), _vm._v(", part 66.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn67",
      "id": "r_fn67"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("67")])]), _vm._v(" Craig-Brown Papers, "), _c('em', [_vm._v("Army Quarterly")]), _vm._v(", Volume 102 No. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn68",
      "id": "r_fn68"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("68")])]), _vm._v(" Anthony Babington, op cit.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a991deda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_Chapter1.vue
// module id = 78
// module chunks = 0